import type { ClientSpecialPostChangeRequest } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useQueryClient } from '@tanstack/react-query';

import { POST_MUTATION_KEYS } from '@/features/api/constants/mutation';
import { useGrapevineSpecialPostEventsApi } from '@/features/api/hooks/grapevine-post-events/useGrapevineSpecialPostEventsApi';
import { useApiMutation } from '@/features/api/hooks/useApiMutation';
import { invalidatePostCachesForChangedPost } from '@/features/api/utils/postCaches';

export const useChangeSpecialPost = () => {
  const queryClient = useQueryClient();
  const api = useGrapevineSpecialPostEventsApi();

  return useApiMutation({
    mutationKey: [POST_MUTATION_KEYS.CHANGE],
    mutationFn: (
      clientSpecialPostChangeRequest: ClientSpecialPostChangeRequest
    ) => api.onSpecialPostChangeRequest({ clientSpecialPostChangeRequest }),
    onSuccess: ({ post }) =>
      invalidatePostCachesForChangedPost(queryClient, post)
  });
};
